import {Directive, EventEmitter, HostListener, Inject, Input, Output, DOCUMENT} from '@angular/core';
import {WindowRef} from '@spartacus/core';


@Directive({
    selector: '[aimoCopyClipboard]',
    standalone: false
})
export class CopyClipboardDirective {
    @Input('aimoCopyClipboard')
    public payload: string;

    @Output()
    public copied: EventEmitter<string> = new EventEmitter<string>();

    constructor(protected winRef: WindowRef,
                @Inject(DOCUMENT) protected document: Document,) {
    }

    @HostListener('click', ['$event'])
    public onClick(event: MouseEvent): void {
        event.preventDefault();
        if (!this.payload) return;
        this.document.defaultView.navigator.clipboard.writeText(this.payload);
        this.copied.emit(this.payload);
    }
}
